module.exports = __webpack_public_path__ + "5c4e1703a63557d8e63eb0644e5850a3.png";